module.exports = __webpack_public_path__ + "img/activity.acad86d2.png";